<template>

<component-module moduleName="promotions_module">
    <template v-slot:programName>Promotions</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem, index) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
            <!-- <div class="menu-nav-extra">
                <router-link class="link" to="/legacy/emailblastmaintenance.php" key="sub-menu-item-legacy-1">Legacy Email Blast Program</router-link>
            </div> -->
            <router-link to="/help-center/articles/7" class="link menu-nav-extra">Help Center <i class="fa fa-chevron-right"/> Promotions</router-link>
        </div>
    </template>
</component-module>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
import './promotions.scss'
export default {
    created() {
        this.updateCustomModuleName('Promotions');
    },
    computed: {
        mainMenu() {
            if (!this.getModuleNavMenu) return {}
            return this.getModuleNavMenu
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'promotions') {
                    return menuItem
                }
            }
        }
    }
}
</script>

<style>

</style>
